import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_PATHS } from '../constants/app-routes';
import { USER_ROLES } from '../constants/roles';
import { AuthService } from '../services/auth.service';

export const consumerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated() && auth.user()?.role === USER_ROLES.consumer) {
    return true;
  }
  return router.createUrlTree([APP_PATHS.passaporteEnter], {
    queryParams: { retorno: APP_PATHS.passaporteAccount }
  });
};
